import StudioFlowAPI from 'dashboard/api/studio/flow';
import { createStore } from '../captain/storeFactory';

export default createStore({
  name: 'StudioFlow',
  API: StudioFlowAPI,
  actions: mutationTypes => ({
    async compile({ commit }, id) {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await StudioFlowAPI.compile(id);
        commit(mutationTypes.EDIT, response.data);
        return response.data;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
    async duplicate({ commit }, id) {
      commit(mutationTypes.SET_UI_FLAG, { creatingItem: true });
      try {
        const response = await StudioFlowAPI.duplicate(id);
        commit(mutationTypes.ADD, response.data);
        return response.data;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { creatingItem: false });
      }
    },
  }),
});
